import { createSelector } from 'reselect';
import { some, identity } from 'lodash';
import hasActiveUploads from './has-active-uploads';
import { getIsLoading } from '../selectors/is-loading-selectors';

const nthArg = n => (...args) => args[n];
const getFormErrors = createSelector(
  [nthArg(1), nthArg(2), nthArg(3), nthArg(4)],
  (errors, fields) =>
    errors.content
      ? errors
      : {
          ...errors,
          content: fields.content.value && hasActiveUploads(fields.content.value) ? 'uploading' : false,
        },
);

/*
redux-form validation is not triggered when image & oembed is loaded, because draft-js stores entities outside EditorState.
This function solves it by setting 'props.errors.content', 'props.valid', 'props.invalid'
whenever state.isLoading.upload or state.isLoading.oembed changes
 */
const decoratePostFormProps = mapStateToProps => (state, props) => {
  const { errors, fields } = props;
  const { upload, oembed } = getIsLoading(state);
  const formErrors = getFormErrors(state, errors, fields, upload, oembed);
  const invalid = some(formErrors, identity);
  const valid = !invalid;
  return {
    ...mapStateToProps(state, props),
    errors: formErrors,
    invalid,
    valid,
  };
};

export default decoratePostFormProps;
